import * as CheckMark from "@src/shared/assets/images/check_mark.inline.svg";
import { readableColor } from "polished";
import styled, { css } from "styled-components";

interface IRootStyleProps {
    color: string;
    isSelected: boolean;
}
export const Root = styled.div<IRootStyleProps>`
    display: block;
    width: 40px;
    height: 40px;
    border-radius: 50%;
    border: 1px solid ${({ isSelected, theme }) => (isSelected ? theme.colors.porscheBankBlue : theme.colors.gray4)};
    margin: 5px;
    padding: 2px;
    cursor: pointer;

    ${({ isSelected }) =>
        isSelected &&
        css`
            box-shadow: 0 6px 6px 0 rgba(0, 0, 0, 0.07);
        `}

    ${({ theme }) => theme.breakpoints.lg.mediaquery} {
        width: 32px;
        height: 32px;
        padding: 5px;
    }
`;
export interface IInnerCircleStyleProps {
    color: string;
}
export const InnerCircle = styled.div<IInnerCircleStyleProps>`
    width: 34px;
    height: 34px;
    border-radius: 50%;
    background-color: ${(props) => props.color};
    color: ${({ color }) => readableColor(color)};
    display: flex;
    align-items: center;
    justify-content: center;

    ${({ theme }) => theme.breakpoints.lg.mediaquery} {
        width: 20px;
        height: 20px;
        padding: 1px;
    }
`;

export const SelectedIcon = styled(CheckMark)`
    ${({ theme }) => theme.breakpoints.lg.mediaquery} {
        width: 18px;
        height: 18px;
    }
`;
